module.exports = __webpack_public_path__ + "images/newspin.gif";